import React from "react";
import { StarGlyph, ZigguratDivider, CuneiformMotif } from "../Ornaments";

export const Footer = () => {
  return (
    <footer
      data-testid="footer-section"
      style={{
        background: "#0a0806",
        borderTop: "1px solid rgba(201, 168, 76, 0.15)",
        padding: "4rem 1.5rem 2.5rem",
        textAlign: "center",
        position: "relative",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
        <ZigguratDivider width={200} height={22} />
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
        <StarGlyph size={24} />
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
        <CuneiformMotif width={180} />
      </div>
      <p
        className="font-heading"
        style={{
          color: "var(--gold-deep)",
          fontSize: "0.7rem",
          letterSpacing: "0.4em",
          textTransform: "uppercase",
        }}
        data-testid="footer-copy"
      >
        © 2026 Somatic Equilibrium · All Rights Reserved
      </p>
    </footer>
  );
};
